export default __webpack_public_path__ + "static/media/fps.e035120a.png";